// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

import { commonActions } from "./common-actions";
import { commonShortFieldLabels, commonShortNouns } from "./common-short-fields";
import { environmentCommonFields } from "./environment-common-fields";
import { environmentCommonObjects } from "./environment-common-objects";
import { environmentCommonValues } from "./environment-common-values";

export const environmentTopologyVersions = {
  title: "Topology Versions",
  subtitle: "Frozen snapshots, release objects, and lineage carriers for topology templates.",
  summaryTotal: "Total",
  summaryPublished: environmentCommonValues.status.published,
  summaryDraft: environmentCommonValues.status.draft,
  summaryArchived: environmentCommonValues.status.archived,
  summaryShared: environmentCommonValues.visibility.shared,
  columns: {
    code: commonShortFieldLabels.code,
    name: "Topology Version",
    imageIdentifier: "Version Identifier",
    imageTitle: "Version Name",
    status: commonShortNouns.status,
    shareMode: environmentCommonFields.shareMode,
    versionNo: "Version",
    nodeCount: "Nodes",
    networkCount: "Networks",
    accessPointCount: "Access Points",
    roleCount: "Roles",
    derivationType: "Derivation",
    tags: environmentCommonFields.tags,
    description: environmentCommonFields.description,
    createdAt: commonShortFieldLabels.createdAt,
    actions: commonShortNouns.actions,
  },
  actions: {
    refresh: commonActions.refresh,
    viewDetail: "View Detail",
    share: commonActions.share,
  },
  forms: {
    topologyTemplate: environmentCommonObjects.topologyTemplate,
    displayName: environmentCommonFields.displayName,
    description: commonShortFieldLabels.description,
    tags: environmentCommonFields.tags,
    tagsPlaceholder: "Comma separated, for example published, web",
    requiredTopologyTemplate: "Please select topology template",
    requiredStatus: "Please select status",
    requiredShareMode: "Please select share mode",
  },
  scopes: {
    mine: "Mine",
    shared_with_me: "Shared with me",
    public: "Public",
    all: "All",
  },
  shareMode: {
    private: environmentCommonValues.visibility.private,
    shared_to_users: "Direct Share",
    public: "Public",
  },
  share: {
    title: "Share Topology Version",
    notice:
      "Sharing has been separated from topology version editing. Use the edit drawer for version metadata and this drawer for sharing governance only.",
    publicDescription:
      "Once shared to the public area, any user with access to this platform entry can see the topology version.",
    selectedUsersTitle: "Shared Users",
    emptyUsers: "No direct-share users yet",
    actions: {
      pickUsers: "Pick users from organization",
    },
    fields: {
      capabilities: "Granted Capabilities",
    },
    capabilities: {
      view: "View",
      reference: "Reference",
      clone: "Clone",
    },
    errors: {
      selectAtLeastOneUser: "Select at least one user to share with",
      selectCapabilities: "Select at least one capability",
    },
    messages: {
      saveSuccess: "Topology version sharing settings saved",
      saveFailed: "Failed to save topology version sharing settings",
    },
  },
  drawers: {
    topologyViewSnapshot: environmentCommonObjects.topologyViewSnapshot,
  },
  preview: {
    title: "Topology Preview",
    ariaLabel: "Topology version view snapshot preview",
    empty: "This version does not have an X6 view snapshot available for preview yet.",
    readonlyDescription:
      "This read-only panel shows the frozen X6 view snapshot for the current topology version and does not allow editing.",
  },
  status: {
    published: environmentCommonValues.status.published,
  },
  errors: {
    loadFailed: "Failed to load topology versions",
  },
} as const;
